import AuthSvcMod from '@Services/Auth.svc.js';
/** @typedef {import('./Intercom.svc')} Types */
//
export class Intercom {
	constructor(ENV, $q, $http, $log, $window, $timeout, $state, AuthSvc) {
		'ngInject';
		this.ENV = ENV;
		this.$q = $q;
		this.$http = $http;
		this.$log = $log;
		this.$window = $window;
		this.timeout = $timeout;
		this.state = $state;
		this.authService = AuthSvc;
	}

	/** @param {Object} currentUser */
	boot(currentUser) {
		if (currentUser && 'Intercom' in this.$window && typeof this.$window.Intercom === 'function') {
			try {
				this.$window.Intercom('boot', {
					app_id: 'wmg4i4pq',
					email: currentUser.email,
					user_id: currentUser.id,
					name: currentUser.first_name + ' ' + currentUser.last_name,
					last_login: currentUser.last_login,
					from_app: 'App',
					from_screen: this.state.current.name,
					created_at: Date.now(),
					user_role: this.authService.isAdmin(currentUser) ? 'admin' : 'consultant',
					company: {
						id: currentUser.service_provider_id,
						name: currentUser.service_provider_name,
						phone: currentUser.mobile_phone,
					},
					avatar: {
						type: 'avatar',
						image_url: currentUser.logo_url,
					},
				});
				this.$log.info('Intercom:boot');
			} catch (e) {
				this.$log.warn(e);
			}
		} else {
			this.timeout(() => this.boot(currentUser), 60000);
		}
	}

	/** @param {Object} object */
	update(object) {
		if ('Intercom' in this.$window && typeof this.$window.Intercom === 'function') {
			try {
				this.$window.Intercom('update', object);
				this.$log.info('Intercom:update');
			} catch (e) {
				this.$log.warn(e);
			}
		}
	}

	shutdown() {
		if ('Intercom' in this.$window && typeof this.$window.Intercom === 'function') {
			try {
				this.$window.Intercom('shutdown');
				this.$log.info('Intercom:shutdown');
			} catch (e) {
				this.$log.warn(e);
			}
		}
	}

	hide() {
		if ('Intercom' in this.$window && typeof this.$window.Intercom === 'function') {
			try {
				this.$window.Intercom('hide');
				this.$log.info('Intercom:hide');
			} catch (e) {
				this.$log.warn(e);
			}
		}
	}
}
//
let compMod = angular.module('mod.svc.IntercomService', [AuthSvcMod]).service('IntercomService', Intercom);
export default (compMod = compMod.name);
